(function () {
  var KLAVIYO_REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  // _kx est ajouté par Klaviyo aux liens de ses emails ; le script Klaviyo le garde ensuite dans le cookie __kla_id.
  function exchangeId(params) {
    var kx = params.get('_kx');
    if (kx) return kx;
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return null;
    try {
      return JSON.parse(atob(decodeURIComponent(m[1])))['$exchange_id'] || null;
    } catch (e) {
      return null;
    }
  }

  function toE164(raw) {
    var v = String(raw || '').replace(/[\s.\-()\/]/g, '');
    if (v.indexOf('00') === 0) v = '+' + v.slice(2);
    if (/^0[1-9]\d{8}$/.test(v)) v = '+33' + v.slice(1);
    else if (/^33[1-9]\d{8}$/.test(v)) v = '+' + v;
    else if (/^[67]\d{8}$/.test(v)) v = '+33' + v;
    if (!/^\+[1-9]\d{7,14}$/.test(v)) return null;
    if (v.indexOf('+33') === 0 && !/^\+33[67]\d{8}$/.test(v)) return null;
    return v;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    var cfg = root.dataset;
    var form = root.querySelector('[data-vip-form]');
    var countdown = root.querySelector('[data-vip-countdown]');
    var params = new URLSearchParams(window.location.search);
    var storeKey = 'mgm_vip_' + cfg.listId;
    var closeAt = Date.parse(cfg.closeAt);
    var kx = exchangeId(params);
    var profile = { email: null, firstName: null, kx: null };

    function isClosed() {
      return !isNaN(closeAt) && Date.now() >= closeAt;
    }

    function show(step) {
      form.dataset.step = step;
      form.querySelectorAll('[data-step-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.stepPanel !== step;
      });
      if (step === 'done') {
        var title = form.querySelector('[data-vip-done-title]');
        var base = title.dataset.title;
        title.textContent = profile.firstName ? profile.firstName + ', ' + base.charAt(0).toLowerCase() + base.slice(1) : base;
      }
      if (step === 'closed' && countdown) countdown.hidden = true;
      root.dispatchEvent(new CustomEvent('vip:step', { bubbles: true, detail: { step: step, variant: form.dataset.variant || 'signup', email: profile.email, firstName: profile.firstName } }));
    }

    function setError(scope, msg) {
      var el = scope.querySelector('[data-vip-error]');
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    function markInvalid(input, invalid) {
      if (invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }

    function subscribe(attributes, channel) {
      var subscriptions = {};
      subscriptions[channel] = { marketing: { consent: 'SUBSCRIBED' } };
      attributes.subscriptions = subscriptions;
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.source,
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          accept: 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.status === 202 || res.status === 200) return;
        return res.text().then(function (t) {
          throw new Error('Klaviyo ' + res.status + ' ' + t);
        });
      });
    }

    function busy(button, on) {
      if (on) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    var signup = form.querySelector('[data-vip-signup]');
    signup.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isClosed()) return show('closed');
      var nameInput = signup.elements.first_name;
      var emailInput = signup.elements.email;
      var name = nameInput.value.trim();
      var email = emailInput.value.trim().toLowerCase();
      markInvalid(nameInput, !name);
      markInvalid(emailInput, !EMAIL_RE.test(email));
      if (!name || !EMAIL_RE.test(email)) {
        setError(signup, name ? cfg.errorEmail : cfg.errorName);
        (name ? emailInput : nameInput).focus();
        return;
      }
      setError(signup, '');
      var button = signup.querySelector('button[type="submit"]');
      busy(button, true);
      subscribe({ email: email, first_name: name }, 'email')
        .then(function () {
          profile = { email: email, firstName: name, kx: null };
          store(storeKey, 'email');
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            window.klaviyo.identify({ email: email, first_name: name });
          }
          form.dataset.variant = 'signup';
          show('phone');
          form.querySelector('[data-vip-phone] input').focus();
        })
        .catch(function (err) {
          console.error('[vip]', err);
          setError(signup, cfg.errorGeneric);
        })
        .then(function () {
          busy(button, false);
        });
    });

    var phoneForm = form.querySelector('[data-vip-phone]');
    phoneForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isClosed()) return show('closed');
      var input = phoneForm.elements.phone;
      var phone = toE164(input.value);
      markInvalid(input, !phone);
      if (!phone) {
        setError(phoneForm, cfg.errorPhone);
        input.focus();
        return;
      }
      setError(phoneForm, '');
      var attributes = { phone_number: phone };
      if (profile.email) attributes.email = profile.email;
      else if (profile.kx) attributes._kx = profile.kx;
      var button = phoneForm.querySelector('button[type="submit"]');
      busy(button, true);
      subscribe(attributes, 'sms')
        .catch(function (err) {
          if (!attributes._kx || err.message.indexOf('_kx') === -1) throw err;
          delete attributes._kx;
          profile.kx = null;
          return subscribe(attributes, 'sms');
        })
        .then(function () {
          store(storeKey, 'done');
          show('done');
        })
        .catch(function (err) {
          console.error('[vip]', err);
          setError(phoneForm, cfg.errorGeneric);
        })
        .then(function () {
          busy(button, false);
        });
    });

    form.querySelector('[data-vip-skip]').addEventListener('click', function () {
      store(storeKey, 'done');
      show('done');
    });

    var reset = form.querySelector('[data-vip-reset]');
    if (reset) reset.addEventListener('click', function () {
      store(storeKey, null);
      profile = { email: null, firstName: null, kx: null };
      signup.reset();
      phoneForm.reset();
      form.dataset.variant = 'signup';
      show('signup');
      signup.elements.first_name.focus();
    });

    function tick() {
      if (isNaN(closeAt) || !countdown) return;
      var left = closeAt - Date.now();
      if (left <= 0) {
        show('closed');
        return clearInterval(timer);
      }
      var s = Math.floor(left / 1000);
      countdown.querySelector('[data-unit="d"]').textContent = Math.floor(s / 86400);
      countdown.querySelector('[data-unit="h"]').textContent = pad(Math.floor((s % 86400) / 3600));
      countdown.querySelector('[data-unit="m"]').textContent = pad(Math.floor((s % 3600) / 60));
      countdown.querySelector('[data-unit="s"]').textContent = pad(s % 60);
      countdown.hidden = false;
    }

    var timer = null;
    if (isClosed()) {
      show('closed');
    } else {
      tick();
      timer = setInterval(tick, 1000);
      if (params.get('vip') === '1' && kx) {
        profile.kx = kx;
        form.dataset.variant = 'clicked';
        show(store(storeKey) === 'done' ? 'done' : 'phone');
      } else if (store(storeKey) === 'done') {
        show('done');
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-vip]').forEach(function (root) {
      if (root.dataset.vipReady) return;
      root.dataset.vipReady = '1';
      init(root);
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#vip-form"]');
    var form = document.getElementById('vip-form');
    if (!link || !form) return;
    e.preventDefault();
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var target = form.querySelector('[data-step-panel]:not([hidden]) input') || form;
    setTimeout(function () {
      target.focus({ preventScroll: true });
    }, 450);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
